import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator, ValidationErrors} from '@angular/forms';
import {createStaticValidator} from './common';

const LowercasePattern = /[a-z]/;
export const Lowercase = createStaticValidator((control: AbstractControl) => LowercasePattern.test(control.value), {
  lowercase: true,
});

@Directive({
  selector: '[lowercase]',
  providers: [{provide: NG_VALIDATORS, useExisting: LowercaseDirective, multi: true}],
})
export class LowercaseDirective implements Validator {
  validate = Lowercase;
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/lowercase.validator.ts